var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"send-egift-panel-review"},[_c('send-egift-panel-review-fields',_vm._g(_vm._b({},'send-egift-panel-review-fields',{ ..._vm.$props },false),_vm.$listeners)),_c('send-egift-panel-review-summary',_vm._g(_vm._b({},'send-egift-panel-review-summary',{ ..._vm.$props },false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }